// extracted by mini-css-extract-plugin
export default {"agreement":"ES8Xs","header":"IjNq_","list":"ic8Ok","mailLink":"PiF1t"};